<template>
  <div class="table-export">
    <div class="main mb-3">
      <table class="table">
        <thead>
          <tr>
            <th v-for="(column, i) of columns" :key="`head-${i}`">
              <div :class="column.classes || []" class="table-title">{{ column.label }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(row, indexRow) of rows" :key="`row-${indexRow}`">
            <tr>
              <td v-for="(column, i) of columns" :key="`row-col-${i}`" :class="column.classes || []">
                <div v-if="column.key != 'details'" v-html="displayData(row, column)" :class="getCss(row, column)"></div>
                <div v-else>
                  <button @click="selectRow(row)" :title="getRowTitleText(row)" class="button button-detail">
                    {{selectedRow != row ? "Open" : "Close"}}
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="selectedRow == row">
              <td v-for="(column, i) of columns" :key="`row-col-${i}`" :class="column.classes || []" class="border-0 p-1 opened-up"></td>
            </tr>
            <tr v-if="selectedRow == row">
              <td :colspan="columns.length" class="border-0 row-detail">
                <slot name="rowdetail" :row="row"></slot>
              </td>
            </tr>
            <tr v-if="selectedRow == row">
              <td v-for="(column, i) of columns" :key="`row-col-${i}`" :class="column.classes || []" class="border-0 p-1 opened-down"></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="export mb-3">
      <button @click="exportData()" title="Download table as CSV file" class="btn btn-secondary"><span class="fa fa-file-download"></span></button>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";

export default {
  name: "Table",
  props: {
    columns: Array,
    rows: Array,
    unparseConfig: Object,
    fileName: String
  },
  data() {
    return {
      selectedRow: null
    }
  },
  methods: {
    displayData(row, column) {
      return column.dataFunction ? column.dataFunction(this.lookupData(row, column)) : this.lookupData(row, column);
    },
    lookupData(row, column) {
      return column.lookupFunction ? column.lookupFunction(row[column.key]) : row[column.key];
    },
    getCss(row, column) {
      return column.cssFunction ? column.cssFunction(row) : "";
    },
    getRowTitleText(row) {
      return ((this.selectedRow != row) ? "Open" : "Close") + " the response strategy";
    },
    selectRow(row) {
      if (this.selectedRow == row) {
        this.selectedRow = null;
      } else {
        this.selectedRow = row;
        this.$emit("open", row);
      }
    },
    exportData() {
      const headers = this.columns.map(column => column.label);
      const rows = this.rows.map(row => this.columns.map(column => column.exportFunction ? column.exportFunction(this.lookupData(row ,column)) : this.lookupData(row, column)));
      const csv = "\uFEFF" + Papa.unparse([headers, ...rows], this.unparseConfig);
      const blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
      const url = URL.createObjectURL(blob);
      const fileName = this.fileName.toLowerCase().split(/[^a-z0-9]+/).filter(notEmpty => notEmpty).join("-") + ".csv";
      const exportAnchor = document.createElement("a");
      exportAnchor.href = url;
      exportAnchor.download = fileName;
      exportAnchor.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
.table-export {
  display: flex;
  min-height: 220px;
  flex-direction: column;
}
.main {
  overflow-y: auto;
}
.export {
  .btn {
    --bs-btn-padding-y: 0;
    --bs-btn-padding-x: 0.5rem;
    --bs-btn-font-size: 1.5rem;
  }
}
.button-detail {
  width: 120px;
}
.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0 0 0;
  color: #fff;
  background-color: var(--bs-orange);
  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.table-title {
  min-height: 70px;
  padding: 0.325rem 0.5rem 0.5rem;

  &.left-row:first-child {
    border-top-left-radius: 10px;
  }

  &.right-row:first-child {
    border-top-right-radius: 10px;
  }
}

tbody {
  tr:last-child {
    .left-row {
      border-bottom-left-radius: 10px;
    }

    .right-row {
      border-bottom-right-radius: 10px;
    }
  }

  .row-detail {
    background-color: #eceff1;
    border-radius: 10px;
    max-width: 100px;
    .row {
      width: calc(100% - 15px);
    }
  }
}

.group {
  color: var(--bs-body-color);
  background-color: #eceff1;
}

.white-space {
  &.opened-up {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/right-bottom-radius.svg");
      content: "";
    }

    &::before {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/left-bottom-radius.svg");
      content: "";
    }
  }

  &.opened-down {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/right-top-radius.svg");
      content: "";
    }

    &::before {
      position: absolute;
      left: 0;
      top: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/left-top-radius.svg");
      content: "";
    }
  }
}

.left-before-row {
  &.opened-up {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/right-bottom-radius.svg");
      content: "";
    }
  }

  &.opened-down {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/right-top-radius.svg");
      content: "";
    }
  }
}

.right-after-row {
  &.opened-up {
    position: relative;

    &::before {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/left-bottom-radius.svg");
      content: "";
    }
  }

  &.opened-down {
    position: relative;

    &::before {
      position: absolute;
      left: 0;
      top: 0;
      width: 20px;
      height: 20px;
      background: url("../../assets/img/icons/left-top-radius.svg");
      content: "";
    }
  }
}
</style>
